var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section has-text-centered-mobile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.titulo))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitulo))]),_c('div',{staticClass:"is-divider is-secundary"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }